import Config from "~/config";
import authorizationHeader from "~/services/authorizationHeader";

const getHeaders = () => {
	const tokenStr = window.localStorage.getItem("appTokens");
	let tokens: Partial<TokenSet> = {};
	if (tokenStr) {
		try {
			tokens = JSON.parse(tokenStr);
		} catch {
			/* corrupted localStorage */
		}
	}
	return {
		"App-Install-Id": localStorage.getItem("App-Install-Id") || "",
		"App-Version": Config.releaseVersion,
		Authorization: authorizationHeader(tokens["accessToken"] || "")
	};
};

export default getHeaders;
